export default function Fab({ ...props }) {
  return (
    <button
      {...props}
      className="flex items-center gap-2 z-50  fixed bottom-0 right-0 m-8 text-white px-4 py-2 rounded-full shadow-lg bg-[#8FC150] hover:bg-[#7eae43] transition-all duration-300"
    />
  );
}
